//#region src/menu_navigation_view_type.ts
let MenuNavigationViewType = /* @__PURE__ */ function(MenuNavigationViewType) {
	MenuNavigationViewType["Top"] = "top";
	MenuNavigationViewType["Side"] = "side";
	MenuNavigationViewType["TopAndSide"] = "top-and-side";
	return MenuNavigationViewType;
}({});
//#endregion
export { MenuNavigationViewType };

//# sourceMappingURL=menu_navigation_view_type.js.map